<template>
  <div>
    <ul class="list">
      <li v-for="(i, a) in property" :key="a">
        <div></div>
        <span>{{ i }}</span>
        <div></div>
      </li>
    </ul>
    <ul class="list-now" v-for="(item, i) in separator" :key="i">
      <li>{{ item.time}}</li>
      <li>{{ item.NAME}}</li>
      <li>{{ item.ALARMNAME}}</li>
      <li>{{ item.ALARMVALUE}}</li>
      <li>{{ item.ALARMRH}}</li>
      <li>{{ item.ALARMRL}}</li>
    </ul>
  </div>
</template>
<script>
 
export default {
  data() {
    return {
      property: [
        "时间",
        "点位名称",
        "报警参数",
        "报警参数值",
        "报警参数上限",
        "报警参数下限",
      ],
      separator: [
        {
          "time":"2022-07-12",
          "NAME":"01",
          "ALARMNAME":"j-1",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        },
        {
          "time":"2022-07-12",
          "NAME":"02",
          "ALARMNAME":"j-2",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        },{
          "time":"2022-07-12",
          "NAME":"03",
          "ALARMNAME":"j-3",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        },{
          "time":"2022-07-12",
          "NAME":"04",
          "ALARMNAME":"j-4",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        },{
          "time":"2022-07-12",
          "NAME":"05",
          "ALARMNAME":"j-1",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        },{
          "time":"2022-07-12",
          "NAME":"06",
          "ALARMNAME":"j-1",
          "ALARMVALUE":"22.224",
          "ALARMRH":"1000",
          "ALARMRL":"1"
        }
      ],
    };
  },
  mounted() {
    // this.getData();
  },methods:{
    getData(){
      let data = new Date();
      let year = data.getYear();
      let mouth = data.getMonth()+1;
      let day= data.getDate();
      let time = year+":"+mouth+":"+day + " 00:00:00"
      
    }

  }
};
</script>
<style lang="less" scoped>
.list {
  width: 66%;
  height: 4vh;
  // border: 1px solid red;
  background-image: url("../assets/lisyt.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position-y: bottom;
  list-style: none;
  color: rgb(0, 255, 234);
  display: flex;
  align-items: center;
  & li:first-child {
    width: 9vw;
    .displaY();
    height: 80%;
  }
  & li {
    width: 7.8vw;
    .displaY();
    height: 80%;
    font-size: 0.8vw;
    font-family: "SOURCEHANSANSCN-REGULAR";
    background-color: rgb(0, 63, 80);
    div {
      width: 10px;
      height: 2px;
      background: #00ffea;
    }
    span {
      margin: 0 0.5vw;
    }
  }
  & li:nth-child(5) ~ li {
    width: 8.1vw;
    .displaY();
    height: 80%;
  }
}
.list-now {
  width: 66%;
  height: 3vh;
  // border: 1px solid red;
  margin: 0.2vh 0;
  //   padding: 0.5vh 0;
  border-bottom: 1px dashed #63807e;
  .displaY();
  & li:first-child {
    width: 9vw;
    .displaY();
    height: 80%;
  }
  & li {
    width: 7.8vw;
    .displaY();
    height: 80%;
    color: rgb(255, 255, 255);
    font-size: 0.5vw;
  }

  & li:nth-child(5) ~ li {
    width: 8.1vw;
    .displaY();
    height: 80%;
  }
}
.list-now:last-child {
  border-bottom: none;
}
.list-now:nth-child(odd) {
  & li {
    background-color: rgba(0, 218, 215, 0.4);
  }
}
</style>